// extracted by mini-css-extract-plugin
export var blogDetail = "article-module--blogDetail--1saCI";
export var description = "article-module--description--xjDuM";
export var fullHeight = "article-module--fullHeight--DWGK8";
export var height = "article-module--height--pLJRF";
export var metaData = "article-module--metaData--r4pW7";
export var title = "article-module--title--BZYG4";
export var user = "article-module--user--w3ciF";
export var wrapper = "article-module--wrapper--S7uPZ";